import React from 'react';
import styles from '../css/vdr.module.css';

const FilingBanner = ({ count = 0, onReview }) => {
    if (!count) return null;

    return (
        <div className={styles.filingBanner}>
            <span>
                {count} file{count === 1 ? '' : 's'} need a VDR location.
            </span>
            <button type="button" className={styles.textLink} onClick={onReview}>
                Review filing →
            </button>
        </div>
    );
};

export default FilingBanner;
